import React, { MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from '@kyruus/intl';
import KyruusLink from '@kyruus/link';

import { Log, MarketableLocation, SearchQuery } from 'Src/types';
import { getBackToSearchUrl } from 'Src/utils/location';
import messages from '../messages';
import { SummaryContainer, SummaryImage } from './styles';
import { Details } from './Details';
import { LOGGING_EVENTS } from '../constants';

interface SummaryProps {
  currentQuery: SearchQuery;
  history: any;
  loading: boolean;
  log: Log;
  marketableLocation?: MarketableLocation;
}

export const Summary = ({
  currentQuery,
  history,
  loading,
  log,
  marketableLocation
}: SummaryProps) => {
  const intl = useIntl();
  const backToSearch = getBackToSearchUrl(currentQuery) || '/search';

  const handleBackToSearchClick = (e: MouseEvent<HTMLAnchorElement>) => {
    // TODO figure out why the router link isn't doing a SPA/client-side transition like it should?
    e.preventDefault();
    log(LOGGING_EVENTS.CLICK_BACK_TO_SEARCH_LINK);
    history.push(backToSearch);
  };

  return (
    <SummaryContainer>
      <Link
        data-testid="BackToSearch"
        to={backToSearch}
        onClick={handleBackToSearchClick}
        component={KyruusLink}
      >
        {intl.formatMessage(messages.backLink)}
      </Link>
      <SummaryImage loading={loading} marketableLocation={marketableLocation} />
      <Details loading={loading} marketableLocation={marketableLocation} />
    </SummaryContainer>
  );
};
